import { useContext } from "react";
import { SearchContext } from "../../../Store/Search.store";
import ActiveFilterButton from "./ActiveFilterButton";
import styles from "./activeSearchFilter.module.css";
import { OptionDt } from "../../../Models/SearchModel";

export default function ActiveSearchFilterButton({clearAllFilters, clearFilter}: {clearAllFilters: () => void, clearFilter: (filter: OptionDt[], filterOrder: number) => void}) {
  const { searchData } = useContext(SearchContext);
  const hideClearFilter = searchData.data.filters.alternativeLevels.some(x => x.isSelected) || searchData.data.filters.alternativeToCategories.some(x => x.isSelected) || searchData.data.filters.certificationsCategories.some(x => x.isSelected) || searchData.data.filters.sectorCategories.some(x => x.isSelected) || searchData.data.filters.suppliers.some(x => x.isSelected) || searchData.data.filters.useCategories.some(x => x.isSelected);

  return (
    <div className={styles.active_filter_container}>
      {searchData.data.filters.alternativeToCategories.map((item) =>
        item.isSelected ? (
          <ActiveFilterButton filter={"Alternative to"} item={item} filterOrder={1} clearFilter={clearFilter} key={item.id} />
        ) : null
      )}
      {searchData.data.filters.sectorCategories.map((item) =>
        item.isSelected ? (
          <ActiveFilterButton filter={"Sector"} item={item} filterOrder={2} clearFilter={clearFilter} key={item.id} />
        ) : null
      )}
    {searchData.data.filters.useCategories.map((item) =>
        item.isSelected ? (
          <ActiveFilterButton filter={"Use"} item={item} filterOrder={3} clearFilter={clearFilter} key={item.id} />
        ) : null
      )}
      {searchData.data.filters.alternativeLevels.map((item) =>
        item.isSelected ? (
          <ActiveFilterButton filter={"Alternative level"} item={item} filterOrder={4} clearFilter={clearFilter} key={item.id} />
        ) : null
      )}
      {searchData.data.filters.suppliers.map((item) =>
        item.isSelected ? (
          <ActiveFilterButton filter={"Supplier"} item={item} filterOrder={5} clearFilter={clearFilter} key={item.id} />
        ) : null
      )}
      {searchData.data.filters.certificationsCategories.map((item) =>
        item.isSelected ? (
          <ActiveFilterButton filter={"Third-party labels and certifications"} item={item} filterOrder={6} clearFilter={clearFilter} key={item.id} />
        ) : null
      )}
      {hideClearFilter ? <button className={styles.clear_filter} onClick={clearAllFilters}>Clear filters</button> : null}
    </div>
  );
}
